// extracted by mini-css-extract-plugin
export default {"wrapper":"MapZoom_wrapper__yxuXq","icon":"MapZoom_icon__lwAM7","plus":"MapZoom_plus__73ufx","minus":"MapZoom_minus__FRh41","divider":"MapZoom_divider__QYfjP"};